import React from 'react';

import { useFeatures } from '@atc/features';

// This container is to trigger optimizely experiments manually when they are used in lazy loaded components or
// middleware that only runs on the server.  That way it will trigger a decision on initial pageload for tagging.
export default function OptimizelyManualTriggerContainer({ features = [] }) {
    const featureResults = useFeatures(features);

    return (
        <div style={{ display: 'none' }}>
            {'<!--' + JSON.stringify(featureResults) + '-->'}
        </div>
    );
}
